import { set } from 'lodash';

import validation from '../../../scripts/services/validation';
import { trackCloseButtonClick, trackGetButtonClick } from './homeowner.tracking';

export default [
  '$scope', 'categoryService', '$sce', 'addressService', 'deviceService',
  function ($scope, categoryService, $sce, addressService, deviceService) {
    $scope.isMobile = deviceService.isMobile;
    $scope.ad = this.ad;
    $scope.form = this.form;
    $scope.promoImage = require('../../../resources/assets/images/homeowner_promo.png');

    const { homeOwner } = this.ad;

    const homeOwnerFiltered = {...homeOwner};
    delete homeOwnerFiltered.houseNumber; // У обявлений с номером дома, это поле заполняется автоматом

    $scope.isShowFields = Object.keys(homeOwnerFiltered).some(name => !!homeOwnerFiltered[name]);

    const cadastralCertificateImage = require('../../../resources/assets/images/cadastral_certificate_example.png');

    $scope.cadastralCertificateExampleHtml = $sce.trustAsHtml(
      `<img src="${cadastralCertificateImage}" width="201" height="256" />` +
      '<br />' +
      'Также вы можете узнать номер в личном кабинете на сайте ' +
      '<a href="https://rosreestr.ru/site/" target="_blank">rosreestr.ru</a>'
    );

    const getAddress = () => {
      const userInput = this.ad.geo.userInput || '';

      let address = this.ad.geo.userInput ? userInput.trim() + ',' : '';

      if (this.ad.geo.details) {
        // Собираем из списка геотипов строку адреса без номера дома
        const { details } = this.ad.geo;

        address = 'Россия, ';

        details.forEach((detail) => {
          if (detail.geoType === 'house') {
            // Номер дома подставляем в поле
            set(this.ad, 'homeOwner.houseNumber', detail.name);
          } else {
            address += `${detail.name}, `;
          }
        });
      }

      return address.trim();
    };

    const updateAddress = () => {
      $scope.address = getAddress();
    };

    updateAddress();

    $scope.isCountry = () => categoryService.isCountry(this.ad.category);
    $scope.isLandSale = () => this.ad.category === 'landSale';

    $scope.handleGetButtonClick = () => {
      $scope.isShowFields = true;

      updateAddress();

      trackGetButtonClick();
    };

    $scope.handleCloseButtonClick = () => {
      $scope.isShowFields = false;

      delete this.ad.homeOwner;

      trackCloseButtonClick();
    };

    $scope.handleHouseNumberBlur = (event) => {
      const address = `${$scope.address} ${event.target.value}`;

      addressService.setAddress(address, false);

      $scope.$emit('address.suggestionChange', address);
    };

    $scope.houseNumberValidation = validation(this.form, 'homeOwner.houseNumber', {
      required: 'Необходимо указать номер дома',
      maxlength: 'Не более 10 символов',
    });
    $scope.flatNumberValidation = validation(this.form, 'homeOwner.flatNumber', {
      required: 'Необходимо указать номер квартиры',
      maxlength: 'Не более 6 символов',
    });
    $scope.cadastralNumberValidation = validation(this.form, 'homeOwner.cadastralNumber', {
      required: 'Необходимо указать кадастровый номер',
      maxlength: 'Не более 20 символов',
      pattern: 'К вводу доступны только цифры и двоеточия',
    });
    $scope.firstNameValidation = validation(this.form, 'homeOwner.firstName', {
      required: 'Необходимо указать имя собственника',
      pattern: 'К вводу доступны только буквы',
    });
    $scope.lastNameValidation = validation(this.form, 'homeOwner.lastName', {
      required: 'Необходимо указать фамилию собственника',
      pattern: 'К вводу доступны только буквы',
    });
    $scope.secondNameValidation = validation(this.form, 'homeOwner.secondName', {
      pattern: 'К вводу доступны только буквы',
    });

    $scope.$on('geo.address.changed', () => {
      updateAddress();
    });
  },
];
